import React from 'react';
var youtubeIcon = /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.3727 3.3C29.0284 2.00114 28.0108 0.978409 26.7205 0.630682C24.3818 1.21919e-07 15 0 15 0C15 0 5.61818 1.21919e-07 3.27955 0.630682C1.9892 0.978409 0.971591 2.00114 0.627273 3.3C4.06395e-08 5.65568 0 10.5682 0 10.5682C0 10.5682 4.06395e-08 15.4807 0.627273 17.8364C0.971591 19.1352 1.9892 20.158 3.27955 20.5057C5.61818 21.1364 15 21.1364 15 21.1364C15 21.1364 24.3818 21.1364 26.7205 20.5057C28.0108 20.158 29.0284 19.1352 29.3727 17.8364C30 15.4807 30 10.5682 30 10.5682C30 10.5682 30 5.65568 29.3727 3.3Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9316 15.029L19.7725 10.5682L11.9316 6.10742V15.029Z",
  fill: "white"
}));
var facebookIcon = /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 15C30 6.71572 23.2843 0 15 0C6.71572 0 0 6.71572 0 15C0 22.4868 5.48525 28.6925 12.6562 29.8178V19.3359H8.84766V15H12.6562V11.6953C12.6562 7.93594 14.8957 5.85938 18.322 5.85938C19.9632 5.85938 21.6797 6.15234 21.6797 6.15234V9.84375H19.7883C17.925 9.84375 17.3438 11.0001 17.3438 12.1863V15H21.5039L20.8389 19.3359H17.3438V29.8178C24.5147 28.6925 30 22.4868 30 15Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8389 19.3359L21.5039 15H17.3438V12.1863C17.3438 11.0001 17.925 9.84375 19.7883 9.84375H21.6797V6.15234C21.6797 6.15234 19.9632 5.85938 18.322 5.85938C14.8957 5.85938 12.6562 7.93594 12.6562 11.6953V15H8.84766V19.3359H12.6562V29.8178C13.42 29.9376 14.2025 30 15 30C15.7975 30 16.58 29.9376 17.3438 29.8178V19.3359H20.8389Z",
  fill: "white"
}));
var xIcon = /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 254 254",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: 'none',
    strokeWidth: 0,
    strokeDasharray: 'none',
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
    strokeMiterlimit: 10,
    fill: 'none',
    fillRule: 'nonzero',
    opacity: 1
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
    strokeMiterlimit: 10,
    fill: '#000',
    fillRule: 'nonzero',
    opacity: 1
  },
  transform: "matrix(2.81 0 0 2.81 1.407 1.407)",
  d: "m24.89 23.01 32.9 43.98h7.45l-32.9-43.98z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 0C20.147 0 0 20.147 0 45s20.147 45 45 45 45-20.147 45-45S69.853 0 45 0zm11.032 70.504L41.054 50.477 22.516 70.504h-4.765L38.925 47.63 17.884 19.496h16.217L47.895 37.94l17.072-18.444h4.765L50.024 40.788l22.225 29.716H56.032z",
  style: {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
    strokeMiterlimit: 10,
    fill: '#000',
    fillRule: 'nonzero',
    opacity: 1
  },
  transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
})));
var instagramIcon = /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 2.89859C18.9416 2.89859 19.408 2.91382 20.9648 2.98472C22.4039 3.05034 23.1855 3.29058 23.7058 3.49273C24.3949 3.7605 24.8865 4.08042 25.4033 4.59663C25.9201 5.11343 26.24 5.60503 26.5072 6.2941C26.7093 6.81441 26.9496 7.59605 27.0152 9.03511C27.0861 10.5914 27.1013 11.0584 27.1013 15C27.1013 18.9416 27.0861 19.408 27.0152 20.9648C26.9496 22.4039 26.7093 23.1855 26.5072 23.7058C26.2394 24.3949 25.9195 24.8865 25.4033 25.4033C24.8865 25.9201 24.3949 26.24 23.7058 26.5072C23.1855 26.7093 22.4039 26.9496 20.9648 27.0152C19.4085 27.0861 18.9416 27.1013 15 27.1013C11.0583 27.1013 10.5914 27.0861 9.03511 27.0152C7.59604 26.9496 6.8144 26.7093 6.29409 26.5072C5.60503 26.2394 5.11343 25.9195 4.59663 25.4033C4.07983 24.8865 3.75991 24.3949 3.49272 23.7058C3.29058 23.1855 3.05034 22.4039 2.98472 20.9648C2.91382 19.4086 2.89858 18.9416 2.89858 15C2.89858 11.0584 2.91382 10.5919 2.98472 9.03511C3.05034 7.59605 3.29058 6.81441 3.49272 6.2941C3.7605 5.60503 4.08042 5.11343 4.59663 4.59663C5.11343 4.07984 5.60503 3.75991 6.29409 3.49273C6.8144 3.29058 7.59604 3.05034 9.03511 2.98472C10.5919 2.91382 11.0583 2.89859 15 2.89859ZM15 0.239014C10.991 0.239014 10.4882 0.256006 8.91382 0.328076C7.34292 0.399561 6.26948 0.64917 5.33081 1.01421C4.35991 1.39155 3.53667 1.89605 2.71636 2.71694C1.89604 3.53726 1.39097 4.3605 1.01362 5.33081C0.648584 6.26949 0.398975 7.34292 0.32749 8.91382C0.256006 10.4882 0.239014 10.991 0.239014 15C0.239014 19.0089 0.256006 19.5117 0.328076 21.0861C0.399561 22.657 0.64917 23.7304 1.01421 24.6691C1.39155 25.64 1.89604 26.4632 2.71694 27.2836C3.53784 28.1045 4.3605 28.609 5.3314 28.9863C6.27007 29.3513 7.34351 29.6009 8.9144 29.6724C10.4888 29.7445 10.9916 29.7615 15.0005 29.7615C19.0095 29.7615 19.5123 29.7445 21.0867 29.6724C22.6576 29.6009 23.731 29.3513 24.6697 28.9863C25.6406 28.609 26.4638 28.1045 27.2841 27.2836C28.105 26.4627 28.6095 25.64 28.9869 24.6691C29.3519 23.7304 29.6015 22.657 29.673 21.0861C29.7451 19.5117 29.7621 19.0089 29.7621 15C29.7621 10.991 29.7451 10.4882 29.673 8.91382C29.6015 7.34292 29.3519 6.26949 28.9869 5.33081C28.6095 4.35991 28.105 3.53667 27.2841 2.71636C26.4632 1.89546 25.6406 1.39097 24.6697 1.01362C23.731 0.648584 22.6576 0.398975 21.0867 0.32749C19.5117 0.256006 19.0089 0.239014 15 0.239014Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0001 7.42017C10.8136 7.42017 7.42041 10.8139 7.42041 14.9998C7.42041 19.1858 10.8136 22.5795 15.0001 22.5795C19.1866 22.5795 22.5798 19.1864 22.5798 14.9998C22.5798 10.8133 19.1866 7.42017 15.0001 7.42017ZM15.0001 19.92C12.2825 19.92 10.08 17.7168 10.08 14.9998C10.08 12.2829 12.2831 10.0797 15.0001 10.0797C17.7177 10.0797 19.9202 12.2829 19.9202 14.9998C19.9202 17.7168 17.7177 19.92 15.0001 19.92Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.8797 8.89146C23.8579 8.89146 24.651 8.09843 24.651 7.12017C24.651 6.14191 23.8579 5.34888 22.8797 5.34888C21.9014 5.34888 21.1084 6.14191 21.1084 7.12017C21.1084 8.09843 21.9014 8.89146 22.8797 8.89146Z",
  fill: "black"
}));
var pinterestIcon = /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 0C6.71605 0 0 6.71605 0 15C0 21.358 3.95062 26.7901 9.53086 28.9753C9.39506 27.7901 9.28395 25.963 9.58025 24.6667C9.85185 23.4938 11.3333 17.2099 11.3333 17.2099C11.3333 17.2099 10.8889 16.3086 10.8889 14.9877C10.8889 12.9012 12.0988 11.3457 13.6049 11.3457C14.8889 11.3457 15.5062 12.3086 15.5062 13.4568C15.5062 14.7407 14.6914 16.6667 14.2593 18.4568C13.9012 19.9506 15.0123 21.1728 16.4815 21.1728C19.1481 21.1728 21.1975 18.358 21.1975 14.3086C21.1975 10.716 18.6173 8.20988 14.9259 8.20988C10.6543 8.20988 8.14815 11.4074 8.14815 14.716C8.14815 16 8.64197 17.3827 9.25926 18.1358C9.38272 18.284 9.39506 18.4198 9.35802 18.5679C9.24691 19.037 8.98765 20.0617 8.93827 20.2716C8.87654 20.5432 8.71605 20.6049 8.4321 20.4691C6.55556 19.5926 5.38272 16.8642 5.38272 14.6543C5.38272 9.92593 8.81481 5.58025 15.2963 5.58025C20.4938 5.58025 24.5432 9.28395 24.5432 14.2469C24.5432 19.4198 21.2839 23.5802 16.7654 23.5802C15.2469 23.5802 13.8148 22.7901 13.3333 21.8519C13.3333 21.8519 12.5802 24.716 12.3951 25.4198C12.0617 26.7284 11.1481 28.358 10.5309 29.358C11.9383 29.7901 13.4198 30.0247 14.9753 30.0247C23.2593 30.0247 29.9753 23.3086 29.9753 15.0247C30 6.71605 23.2839 0 15 0Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: "30",
  height: "30",
  fill: "white"
}))));
export { youtubeIcon, facebookIcon, xIcon, instagramIcon, pinterestIcon };